import { FC } from 'react'
import { Colors } from 'src/components/theme'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

const ItemContainer = styled.div<{ color: string; highlight: 1 | 0; hoverable: 1 | 0 }>`
  border-radius: 4px;
  border: 1px solid ${(props) => props.color};
  display: flex;
  background-color: ${Colors.bgWhite};
  box-shadow: ${(props) => (props.color && props.highlight ? `0px 0px 9px 0px ${props.color}` : 'none')};

  ${({ hoverable }) =>
    hoverable &&
    css`
      &:hover {
        background-color: ${Colors.neutral100};
        cursor: pointer;
      }
    `}
`

const ItemBar = styled.div<{ color?: string }>`
  width: 6px;
  height: auto;
  background-color: ${({ color }) => color || Colors.neutral700};
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
`

const ItemContent = styled.div`
  padding: 4px 8px;
  flex: 1;
  overflow: hidden;
`

export type ColoredItemProps = {
  color?: string
  className?: string
  children: React.ReactNode
  newLevel?: React.ReactNode
  highlight?: boolean
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

// do you have a better name for this component? Because I don't
export const ColoredItem: FC<ColoredItemProps> = ({
  children,
  color,
  highlight,
  onMouseEnter,
  onMouseLeave,
  onClick,
  className,
}) => {
  const hoverable = !!onMouseEnter || !!onMouseLeave || !!onClick

  return (
    <ItemContainer
      className={className}
      color={highlight && color ? color : Colors.neutral100}
      highlight={highlight ? 1 : 0}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      hoverable={hoverable ? 1 : 0}>
      <ItemBar color={color} />
      <ItemContent>{children}</ItemContent>
    </ItemContainer>
  )
}
